import React from "react";
import { FileGroup, InputField } from "../../../components/Form/FormComponents";
import { getFormattedDate } from "../../../utils/DateUtils";
import { Typography } from "@mui/material";

/* eslint-disable react/prop-types */

// General
export const PersonalInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.personal?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>FULL NAME</label>
				<InputField name='fullName' value={formData?.personal?.fullName} />
			</div>

			<div className='form-group'>
				<label>HOME ADDRESS</label>
				<InputField name='homeAddress' value={formData?.personal?.homeAddress} />
			</div>

			<div className='form-group'>
				<label>STATE OF ORIGIN</label>
				<InputField name='stateOfOrigin' value={formData?.personal?.stateOfOrigin} />
			</div>

			<div className='form-group'>
				<label>LGA</label>
				<InputField name='LGA' value={formData?.personal?.LGA} />
			</div>

			<div className='form-group'>
				<label>GENDER</label>
				<InputField name='gender' value={formData?.personal?.gender} />
			</div>

			<div className='form-group'>
				<label>MARITAL STATUS</label>
				<InputField name='maritalStatus' value={formData?.personal?.maritalStatus} />
			</div>

			<div className='form-group'>
				<label>DATE OF BIRTH</label>
				<InputField name='dob' value={formData?.personal?.dob} />
			</div>

			<div className='form-group'>
				<label>RELIGION</label>
				<InputField name='religion' value={formData?.personal?.religion} />
			</div>
		</div>
	);
};

export const ContactInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-4 gap-3'>
			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='contactPhone' value={formData?.contact?.phone} />
			</div>

			<div className='form-group'>
				<label>EMAIL ADDRESS</label>
				<InputField name='contactEmail' value={formData?.contact?.email} />
			</div>

			<div className='form-group'>
				<label>RESIDENTIAL ADDRESS</label>
				<InputField name='contactResidentialAddress' value={formData?.contact?.residentialAddress} />
			</div>

			<div className='form-group'>
				<label>PERMANENT ADDRESS</label>
				<InputField name='contactPermanentAddress' value={formData?.contact?.permanentAddress} />
			</div>

			<Typography variant='h6' sx={{ gridColumn: "1 / 5", fontWeight: 500, marginTop: "2.15rem" }}>
				NEXT OF KIN INFORMATION
			</Typography>

			<div className='form-group'>
				<label>NAME OF NEXT OF KIN</label>
				<InputField name='KINfullName' value={formData?.contact?.nextOfKin?.name} />
			</div>

			<div className='form-group'>
				<label>RELATIONSHIP</label>
				<InputField name='KINrelationship' value={formData?.contact?.nextOfKin?.relationship} />
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='KINphone' value={formData?.contact?.nextOfKin?.phone} />
			</div>

			<div className='form-group'>
				<label>EMAIL ADDRESS</label>
				<InputField name='KINemail' value={formData?.contact?.nextOfKin?.email} />
			</div>

			<div className='form-group'>
				<label>RESIDENTIAL ADDRESS</label>
				<InputField name='KINaddress' value={formData?.contact?.nextOfKin?.address} />
			</div>
		</div>
	);
};

export const BusinessInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-4 gap-3'>
			<div className='form-group'>
				<label>RECENT EMPLOYER</label>
				<InputField name='PFrecentEmployer' value={formData?.profession?.recentEmployer} />
			</div>

			<div className='form-group'>
				<label>START DATE</label>
				<InputField name='PFstartDate' value={formData?.profession?.startDate} />
			</div>

			<div className='form-group'>
				<label>END DATE</label>
				<InputField name='PFendDate' value={formData?.profession?.endDate} />
			</div>

			<div className='form-group'>
				<label>ROLE</label>
				<InputField name='PFrole' value={formData?.profession?.role} />
			</div>

			<div className='form-group'>
				<label>WORK ADDRESS</label>
				<InputField name='PFworkAddress' value={formData?.profession?.workAddress} />
			</div>

			<div className='form-group'>
				<label>INDUSTRY</label>
				<InputField name='PFindustry' value={formData?.profession?.industry} />
			</div>

			<span style={{ gridColumn: "1 / 5" }}></span>

			{/* BUSINESS */}
			<div className='form-group'>
				<label>BUSINESS NAME</label>
				<InputField name='businessDescription' value={formData?.travel?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>REGISTRATION STATUS</label>
				<InputField name='businessDescription' value={formData?.travel?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>BUSINESS TYPE</label>
				<InputField name='businessDescription' value={formData?.travel?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>ROLE</label>
				<InputField name='businessDescription' value={formData?.travel?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>NUMBER OF STAFF</label>
				<InputField name='businessDescription' value={formData?.travel?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>ANNUAL TURNOVER</label>
				<InputField name='businessDescription' value={formData?.travel?.businessDescription} />
			</div>
		</div>
	);
};

export const EducationalInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>HIGHEST QUALIFICATION</label>
				<InputField name='EDhighestQualification' value={formData?.education?.highestQualification} />
			</div>

			<div className='form-group'>
				<label>NAME OF INSTITUTION</label>
				<InputField name='EDinstitutionName' value={formData?.education?.institutionName} />
			</div>

			<div className='form-group'>
				<label>COURSE OF STUDY</label>
				<InputField name='EDcourseOfStudy' value={formData?.education?.courseOfStudy} />
			</div>

			<div className='form-group'>
				<label>DEGREE OBTAINED</label>
				<InputField name='EDdegree' value={formData?.education?.degree} />
			</div>

			<div className='form-group'>
				<label>YEAR OF DEGREE</label>
				<InputField name='EDyearOfDegree' value={formData?.education?.yearOfDegree} />
			</div>
		</div>
	);
};

export const FamilyInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>NUMBER OF DEPENDENTS</label>
				<InputField name='dependentNo' value={formData?.dependent?.length} />
			</div>

			{formData?.dependent?.map((item, index) => (
				<React.Fragment key={index}>
					<Typography variant='h6' sx={{ gridColumn: "1 / 4", fontWeight: 500, marginTop: "2.15rem" }}>
						DETAILS OF DEPENDENT ({index + 1})
					</Typography>

					<div className='form-group'>
						<label>FULL NAME (AS ON PASSPORT)</label>
						<InputField name='DPTfullName' value={item?.fullName} />
					</div>

					<div className='form-group'>
						<label>DATE OF BIRTH</label>
						<InputField name='DPTdob' value={item?.dob} />
					</div>

					<div className='form-group'>
						<label>RELATIONSHIP</label>
						<InputField name='DPTrelationship' value={item?.relationship} />
					</div>

					<div className='form-group'>
						<label>PHONE NUMBER</label>
						<InputField name='DPTphone' value={item?.phone} />
					</div>

					<div className='form-group'>
						<label>EMAIL ADDRESS</label>
						<InputField name='DPTemail' value={item?.email} />
					</div>

					<div className='form-group'>
						<label>EDUCATIONAL LEVEL</label>
						<InputField name='DPTeducationalLevel' value={item?.educationalLevel} />
					</div>
				</React.Fragment>
			))}
		</div>
	);
};

export const TravelInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>DESTINATION COUNTRY</label>
				<InputField name='destinationCountry' value={formData?.travel?.destinationCountry} />
			</div>

			<div className='form-group'>
				<label>EXPECTED DEPARTURE DATE</label>
				<InputField name='expectedDepartureDate' value={formData?.travel?.expectedDepartureDate} />
			</div>

			<div className='form-group'>
				<label>TRAVEL PURPOSES</label>
				<InputField name='travelPurpose' value={formData?.travel?.travelPurpose} />
			</div>

			<div className='form-group'>
				<label>HOW LONG DO YOU INTEND TO STAY?</label>
				<InputField name='lengthOfStay' value={formData?.travel?.lengthOfStay} />
			</div>

			<div className='form-group'>
				<label>FIRST TIME TRAVELLING?</label>
				<InputField name='firstTime' value={formData?.travel?.firstTime ? "Yes" : "No"} />
			</div>
		</div>
	);
};

export const BankInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>Bank</label>
				<InputField name='BANKbank' value={formData?.bank?.bank} />
			</div>

			<div className='form-group'>
				<label>ACCOUNT NUMBER</label>
				<InputField name='BANKaccountNumber' value={formData?.bank?.accountNumber} />
			</div>

			<div className='form-group'>
				<label>ACCOUNT NAME</label>
				<InputField name='BANKaccountName' value={formData?.bank?.accountName} />
			</div>
		</div>
	);
};

export const DetailsOfRequest = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>FUNDING REQUEST AMOUNT</label>
				<InputField name='DORamount' value={formData?.DOR?.amount} />
			</div>

			<div className='form-group'>
				<label>EQUITY CONTRIBUTION</label>
				<InputField name='DORequityContribution' value={formData?.DOR?.equityContribution} />
			</div>

			<div className='form-group'>
				<label>TENOR</label>
				<InputField name='DORtenure' value={formData?.DOR?.tenure} />
			</div>

			{/* <div className='form-group'>
				<label>MONTHLY INTEREST</label>
				<InputField name='DORmonthlyInterest' value={formData?.DOR?.monthlyInterest} />
			</div>

			<div className='form-group'>
				<label>PROGRAMMED LIQUIDATION</label>
				<InputField name='DORprogrammedLiquidation' value={formData?.DOR?.programmedLiquidation} />
			</div> */}

			<div className='form-group'>
				<label>FUNDS INFLOW NARRATION</label>
				<InputField name='DORfundsInflowNarration' value={formData?.DOR?.fundsInflowNarration} />
			</div>
		</div>
	);
};

export const FinancialInformation = ({ formData }) => {
	return (
		<>
			<Typography variant='h6' py={0.85} px={2} sx={{ mt: 2, background: "#EFF8F9" }}>
				ASSET
			</Typography>

			{/* CASH */}
			<div className='grid grid-cols-3 gap-3'>
				<Typography variant='p' sx={{ gridColumn: "1 / 4", fontWeight: 500, mt: 3.85, mb: "-14px" }}>
					CASH
				</Typography>

				<div className='form-group'>
					<label>BANK ACCOUNTS</label>
					<InputField name='CASHbankAccounts' value={formData?.finance?.cash?.bankAccounts} />
				</div>

				<div className='form-group'>
					<label>SAVINGS ACCOUNT</label>
					<InputField name='CASHsavings' value={formData?.finance?.cash?.savings} />
				</div>

				<div className='form-group'>
					<label>CERTIFICATE OF DEPOSIT</label>
					<InputField name='CASHcertificateOfDeposit' value={formData?.finance?.cash?.certificateOfDeposit} />
				</div>

				<div className='form-group'>
					<label>OTHER CASH</label>
					<InputField name='CASHothers' value={formData?.finance?.cash?.others} />
				</div>
			</div>

			{/* INVESTMENT */}
			<div className='grid grid-cols-3 gap-3'>
				<Typography variant='p' sx={{ gridColumn: "1 / 4", fontWeight: 500, mt: 3.85, mb: "-14px" }}>
					INVESTMENT
				</Typography>

				<div className='form-group'>
					<label>LIFE INSURANCE (CASH SURRENDER VALUE)</label>
					<InputField name='INVlifeInsurance' value={formData?.finance?.investment?.lifeInsurance} />
				</div>

				<div className='form-group'>
					<label>BROKERAGE ACCOUNTS (NON-RETIREMENT)</label>
					<InputField name='INVbrokeageAccount' value={formData?.finance?.investment?.brokeageAccount} />
				</div>

				<div className='form-group'>
					<label>SECURITIES (STOCKS, BONDS, MUTUAL BONDS)</label>
					<InputField name='INVsecurities' value={formData?.finance?.investment?.securities} />
				</div>

				<div className='form-group'>
					<label>INVESTMENT REAL ESTATE (MARKET VALUE)</label>
					<InputField name='INVrealEstInvestment' value={formData?.finance?.investment?.realEstInvestment} />
				</div>

				<div className='form-group'>
					<label>TREASURY BILLS/ NOTES</label>
					<InputField name='INVtreasury' value={formData?.finance?.investment?.treasury} />
				</div>

				<div className='form-group'>
					<label>OTHER INVESTMENTS</label>
					<InputField name='INVotherInvestments' value={formData?.finance?.investment?.otherInvestments} />
				</div>
			</div>

			{/* PERSONAL PROPERTY */}
			<div className='grid grid-cols-3 gap-3'>
				<Typography variant='p' sx={{ gridColumn: "1 / 4", fontWeight: 500, mt: 3.85, mb: "-14px" }}>
					PERSONAL PROPERTY
				</Typography>

				<div className='form-group'>
					<label>PRIMARY RESIDENCE (MARKET VALUE)</label>
					<InputField
						name='PPprimaryResidence'
						value={formData?.finance?.personalProperty?.primaryResidence}
					/>
				</div>

				<div className='form-group'>
					<label>AUTOMOBILES (PRESENT VALUE)</label>
					<InputField name='PPautomobiles' value={formData?.finance?.personalProperty?.automobiles} />
				</div>

				<div className='form-group'>
					<label>BULLION</label>
					<InputField name='PPbullion' value={formData?.finance?.personalProperty?.bullion} />
				</div>

				<div className='form-group'>
					<label>JEWELRY, ARTS AND COLLECTIBLES</label>
					<InputField name='PPjewelry' value={formData?.finance?.personalProperty?.jewelry} />
				</div>

				<div className='form-group'>
					<label>OTHER PROPERTY</label>
					<InputField name='PPothers' value={formData?.finance?.personalProperty?.others} />
				</div>
			</div>

			{/* RETIREMENT */}
			<div className='grid grid-cols-3 gap-3'>
				<Typography variant='p' sx={{ gridColumn: "1 / 5", fontWeight: 500, mt: 3.85, mb: "-14px" }}>
					RETIREMENT
				</Typography>

				<div className='form-group'>
					<label>PENSION ACCOUNTS</label>
					<InputField name='RETIREpensionAccounts' value={formData?.finance?.retirement?.pensionAccounts} />
				</div>

				<div className='form-group'>
					<label>OTHER ASSETS</label>
					<InputField name='RETIREothers' value={formData?.finance?.retirement?.others} />
				</div>
			</div>

			{/* NOTES AND ACCOUNTS RECEIVABLE */}
			<div className='grid grid-cols-3 gap-3'>
				<Typography variant='p' sx={{ gridColumn: "1 / 5", fontWeight: 500, mt: 3.85, mb: "-14px" }}>
					NOTES AND ACCOUNTS RECEIVABLE
				</Typography>

				<div className='form-group'>
					<label>OTHER NOTES</label>
					<InputField
						name='NAnotesandAccountReceivable'
						value={formData?.finance?.notesAndAccounts?.notesandAccountReceivable}
					/>
				</div>

				<div className='form-group'>
					<label>OTHER NOTES</label>
					<InputField name='NAothers' value={formData?.finance?.notesAndAccounts?.others} />
				</div>
			</div>

			<Typography
				variant='p'
				className='space-between'
				sx={{ background: "#EFF8F9", mt: 4.85, py: 0.85, px: 2, fontWeight: 500 }}>
				<span>TOTAL ASSETS</span>
				<span className='float-right'>0.00</span>
			</Typography>

			{/* LIABILITIES */}
			<div className='grid grid-cols-3 gap-3'>
				<Typography variant='p' sx={{ gridColumn: "1 / 4", fontWeight: 500, mt: 3.85, mb: "-14px" }}>
					LIABILITIES
				</Typography>

				<div className='form-group'>
					<label>MORTGAGES ON REAL ESTATE</label>
					<InputField name='LI_realEstMort' value={formData?.finance?.liabilities?.realEstMort} />
				</div>

				<div className='form-group'>
					<label>MORTGAGES ON INVESTMENT REAL ESTATE</label>
					<InputField name='LI_InvestRealEstMort' value={formData?.finance?.liabilities?.InvestRealEstMort} />
				</div>

				<div className='form-group'>
					<label>CREDIT ACCOUNTS, BILLS DUE,ETC.</label>
					<InputField name='LI_creditAccount' value={formData?.finance?.liabilities?.creditAccount} />
				</div>

				<div className='form-group'>
					<label>STUDENT LOAN</label>
					<InputField name='LI_studentLoan' value={formData?.finance?.liabilities?.studentLoan} />
				</div>

				<div className='form-group'>
					<label>ACCOUNTS PAYABLE</label>
					<InputField name='LI_accountPayable' value={formData?.finance?.liabilities?.accountPayable} />
				</div>

				<div className='form-group'>
					<label>LOANS AND NOTES PAYABLE TO BANK AND OTHERS</label>
					<InputField name='LI_notesAndLoans' value={formData?.finance?.liabilities?.notesAndLoans} />
				</div>

				<div className='form-group'>
					<label>LOANS ON LIFE INSURANCE</label>
					<InputField name='LI_loansOnLife' value={formData?.finance?.liabilities?.loansOnLife} />
				</div>

				<div className='form-group'>
					<label>LOANS ON PROFIT SHARING/ PENSION</label>
					<InputField name='LI_loansOnProfit' value={formData?.finance?.liabilities?.loansOnProfit} />
				</div>

				<div className='form-group'>
					<label>LOANS ON RETIREMENTS ACCOUNTS</label>
					<InputField name='LI_loansOnRetirement' value={formData?.finance?.liabilities?.loansOnRetirement} />
				</div>

				<div className='form-group'>
					<label>UNPAID TAXES (CURRENT YEAR)</label>
					<InputField name='LI_unpaidTaxes' value={formData?.finance?.liabilities?.unpaidTaxes} />
				</div>

				<div className='form-group'>
					<label>MONTHLY LIVING EXPENSES</label>
					<InputField
						name='LI_monthlyLivingExpenses'
						value={formData?.finance?.liabilities?.monthlyLivingExpenses}
					/>
				</div>

				<div className='form-group'>
					<label>OTHER LIABILITIES</label>
					<InputField name='LI_others' value={formData?.finance?.liabilities?.others} />
				</div>
			</div>

			<Typography
				variant='p'
				className='space-between'
				sx={{ background: "#EFF8F9", mt: 4.85, py: 0.85, px: 2, fontWeight: 500 }}>
				<span>TOTAL LIABILITIES</span>
				<span className='float-right'>
					{Object.keys(formData?.finance?.liabilities || [])?.length.toFixed(2)}
				</span>
			</Typography>

			<Typography
				variant='p'
				className='space-between'
				sx={{ border: "1px solid #B8C8CF", mt: 3, py: 0.85, px: 2, fontWeight: 500 }}>
				<span>NET WORTH (Assets - Liabilities)</span>
				<span className='float-right'>0.00</span>
			</Typography>

			{/* COMMON FINANCIAL RATIOS */}
			<div className='grid grid-cols-3 gap-3'>
				<Typography variant='p' sx={{ gridColumn: "1 / 4", fontWeight: 500, mt: 3.85, mb: "-14px" }}>
					COMMON FINANCIAL RATIOS
				</Typography>

				<div className='form-group'>
					<label>DEBTS TO ASSET RATIO (TOTAL LIABILITIES/ TOTAL ASSETS)</label>
					<InputField
						name='CFR_debtToAssets'
						value={formData?.finance?.commonFinancialRatios?.debtToAssets}
					/>
				</div>

				<div className='form-group'>
					<label>BASIC LIQUIDITY RATIO (LIQUID ASSETS/ MONTHLY LIVING EXPENSES)</label>
					<InputField
						name='CFR_basicLiquidity'
						value={formData?.finance?.commonFinancialRatios?.basicLiquidity}
					/>
				</div>

				<div className='form-group'>
					<label>INBVESTMENT ASSETS TO NET WORTH RATIO (INVESTMENT ASSET/ NET WORTH)</label>
					<InputField
						name='CFR_investmentAssetsToNetworth'
						value={formData?.finance?.commonFinancialRatios?.investmentAssetsToNetworth}
					/>
				</div>
			</div>
		</>
	);
};

export const DocumentationGroup = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>INTERNATIONAL PASSPORT</label>
				<FileGroup name='intlPassport' value={formData?.documentation?.intlPassport?.url} />
			</div>

			<div className='form-group'>
				<label>UTILITY BILL</label>
				<FileGroup name='utilityBill' value={formData?.documentation?.utilityBill} />
			</div>

			<div className='form-group'>
				<label>BANK STATEMENT</label>
				<FileGroup name='bankStatement' value={formData?.documentation?.bankStatement} />
			</div>
		</div>
	);
};
